import { Calendar } from 'primereact/calendar';
import React from 'react';

const C2Calendar = (props) => {
    const { value, selectionMode, onChange } = props;
    const isSingleSelectionMode = typeof selectionMode === "undefined" || selectionMode === "single";
    let calendarValue = null;
    if (isSingleSelectionMode) {
        if (typeof value === "string") {
            calendarValue = new Date(value);
        }
        if (value instanceof Date) {
            calendarValue = value;
        }
        return (React.createElement(Calendar, Object.assign({}, props, { selectionMode: "single", value: calendarValue, appendTo: document.body, onChange: (event) => {
                const { value } = event;
                onChange(Object.assign(Object.assign({}, event), { value: value instanceof Date ? value.toISOString() : value }));
            } })));
    }
    else if (selectionMode === "range") {
        if (Array.isArray(value)) {
            calendarValue = value.map(v => typeof v === "string" ? new Date(v) : v);
        }
        else {
            calendarValue = [];
        }
        return (React.createElement(Calendar, Object.assign({}, props, { selectionMode: "range", value: calendarValue, onChange: (event) => {
                const { value } = event;
                if (Array.isArray(value)) {
                    onChange(Object.assign(Object.assign({}, event), { value: value.map(v => v instanceof Date ? v.toISOString() : v) }));
                }
                else {
                    onChange(Object.assign(Object.assign({}, event), { value }));
                }
            } })));
    }
    else {
        if (Array.isArray(value)) {
            calendarValue = value.map(v => typeof v === "string" ? new Date(v) : v);
        }
        return (React.createElement(Calendar, { selectionMode: "multiple", value: calendarValue }));
    }
};

export { C2Calendar as default };
//# sourceMappingURL=index.js.map
